import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import { NForm, NCard, NSpace, NFormItem, NInputNumber, NSelect, NDataTable } from 'naive-ui'
import helper from "@/helper";
import AppLayoutMixin from "@/app-layout-mixin";
import EmbedCode from "@/components/embed";

createApp({
    components: { NForm, NCard, NSpace, NFormItem, NInputNumber, NSelect, NDataTable, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            unit: 'm',
            a: 100,
            b: 100,
            c: 100,
            units: helper.lengthUnitsGrouped,
            tableColumns: [
                {
                    title: 'Unit',
                    key: 'unit'
                },
                {
                    title: 'Result',
                    key: 'result'
                }
            ]
        }
    },
    computed: {

        result() {
            // calculate the semi-perimeter
            const s = (this.a + this.b + this.c) / 2;
            return Math.sqrt(
                s * (s - this.a) * (s - this.b) * (s - this.c)
            );
        },

        resultTable() {
            const data = [];

            for (let unit in helper.conv.length) {
                data.push({
                    unit: unit + '²',
                    result: (this.result * Math.pow(helper.conv.length[this.unit], 2)) / Math.pow(helper.conv.length[unit], 2)
                });
            }

            return data;
        },

    }
}).mount('#app')
